import {
	Component,
	ViewEncapsulation,
	ViewChild,
	Input,
	ChangeDetectorRef
} from '@angular/core';

import { EventsService } from '@coreui/services/event.service'
import { UIColorModel } from '@coreui/services/ui.color.model.service';
import { ApplicationService } from '../../services/application.service';




@Component({
	selector: 		'discover-screen',
	encapsulation: ViewEncapsulation.None,

	template:	`

	<content-container-scrollable>

	

	</content-container-scrollable>
		
	`,

})


export class DiscoverScreen {

	private changeDetectorRef: ChangeDetectorRef
	private eventsService: EventsService
	uiColorModel: UIColorModel
	applicationService: ApplicationService


	constructor(public ref: ChangeDetectorRef, private _eventsService: EventsService,
		private _uiColorModel: UIColorModel, private _applicationService: ApplicationService) {
		this.changeDetectorRef = ref
		this.eventsService = _eventsService
		this.uiColorModel = _uiColorModel
		this.applicationService = _applicationService
	}

	ngOnInit() {
		this.eventsService.broadcast("onShowModalOverlay", {id: "radar-popup"})
	}

	ngOnDestroy() {
	}

	ngAfterViewInit() {
	}


}
